import { render, staticRenderFns } from "./workers.vue?vue&type=template&id=4624dca8&lang=html&"
import script from "./workers.vue?vue&type=script&lang=js&"
export * from "./workers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports